export const tags = [
    {value: 'Part Time', label: 'Part Time'},
    {value: 'Full Time', label: 'Full Time'},
    {value: 'Distance Learning', label: 'Distance Learning'}
]